<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Field">
      <f-select-field
        v-model="field.params.field"
        label="Field"
        :fields="fields"
        clearable
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Comparison">
      <b-form-select
        :options="comparison_list"
        @change="changeProp"
        text-field="text"
        v-model="field.params.comparison"
        value-field="value"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Match">
      <b-form-select
        :options="match_list"
        @change="changeProp"
        text-field="text"
        v-model="field.params.match_value"
        value-field="value"
      />
    </b-form-group>

    <b-form-group label="Expression" label-cols="3">
      <b-form-input @change="changeProp" v-model="field.params.expression" />
    </b-form-group>

    <b-form-group label-cols="3" label="Widgets">
      <f-child-fields
        :fields="field.fields"
        @change="on_changed_fields"
        @select="on_select"
      />
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import FSelectField from "../../FSelectField.vue";
import { FIELD_TYPES_BY_CODE } from "../../field_types.js";
import WidgetPropMixin from "../WidgetPropMixin.js";
import FChildFields from "../FChildFields.vue";

export default {
  name: "ConditionalProps",
  components: { FChildFields, FSelectField, WidgetCommonProps },
  mixins: [WidgetPropMixin],

  computed: {
    comparison_list() {
      var result = [{ text: "=", value: "eq" }];

      if (this.field.params.field) {
        var field = _.keyBy(this.fields, "code")[this.field.params.field];

        if (field) {
          var field_type = FIELD_TYPES_BY_CODE[this.field.field_type];

          // Decide if it's more than just equals
        }
      }

      return _.sortBy(result, "text");
    },
    match_list() {
      var result = [
        { text: "Yes", value: true },
        { text: "No", value: false },
        { text: "N/A", value: null },
      ];

      return _.sortBy(result, "text");
    },
  },
};
</script>
